import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { PriceListDetailModel } from 'src/app/models/archive/price-list-detail.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { ArticleWithPricesTableModel } from 'src/app/models/tables/archive/article-with-prices-table.model';
import { PriceListDetailCaptureTableModel } from 'src/app/models/tables/archive/price-list-detail-capture-table.model';
import { environment } from 'src/environments/environment';
import { PriceListImportModel } from './../../models/imports/price-list-import.model';
import { PriceListAsImportModel } from 'src/app/models/imports/price-list-as-import.model';

@Injectable({
  providedIn: 'root'
})
export class PriceListDetailService {

  constructor(private _httpClient: HttpClient) { }


  createPriceListDetail(priceListDetailContractModel: PriceListDetailModel): Observable<PriceListDetailModel> {
    return this._httpClient.post<PriceListDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.CreatePriceListDetail}`,
      priceListDetailContractModel);
  }

  createSomePriceListDetail(priceListId: number, articlesId: Array<number>): Observable<PriceListDetailModel> {
    return this._httpClient.post<PriceListDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.CreateSomePriceListDetail}/${priceListId}`,
      articlesId);
  }

  deletePriceListDetail(priceListDetailIds: Array<number>): Observable<PriceListDetailModel> {
    return this._httpClient.put<PriceListDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.DeletePriceListDetail}`,
      priceListDetailIds);
  }

  downloadGuideImportPriceList(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportCaptureDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, priceListId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('priceListId', priceListId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ExportCaptureDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllPriceListDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetAllPriceListDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getArticleIdInPriceListDetails(articleId: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetArticleIdInPriceListDetails}/${articleId}`);
  }

  getBaseUnitValue(branchId: number, articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetBaseUnitValue}/${branchId}/${articleId}`);
  }

  getClientUnitValueByPriceListArticle(priceListId: number, articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetClientUnitValueByPriceListArticle}/${priceListId}/${articleId}`);
  }

  getAllBreakdownsByQuotationForCapture(priceListId: number | null, quotationDetailId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticleWithPricesTableModel>> {
    const params = new HttpParams()
      .set('priceListId', priceListId || 0)
      .set('quotationDetailId', quotationDetailId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticleWithPricesTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetArticlesWithPriceByQuotationWithPagination}`,
      filters, { params: params }
    );
  }

  getColumnsFoArticlesWithPriceByQuotation(quotationTypeId: number): Observable<ColumnResponseModel[]> {
    const params = new HttpParams().set('quotationTypeId', quotationTypeId);
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetColumnsFoArticlesWithPriceByQuotation}`,
      { params: params }
    );
  }

  getColumnsForArticleSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetColumnsForArticleSelectionAsync}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetColumnsForDetailConsultation}`);
  }

  getListArticlesForSelection(priceListId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticleSelectionTableModel>> {
    const params = new HttpParams().set('priceListId', priceListId).set('page', page).set('limit', limit)
      .set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticleSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetListArticlesForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getPriceListDetailById(priceListDetailId: number): Observable<PriceListDetailModel> {
    return this._httpClient.get<PriceListDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetPriceListDetailById}/${priceListDetailId}`);
  }

  getPriceListDetailByKeys(priceListId: number, articleId: number): Observable<PriceListDetailModel> {
    return this._httpClient.get<PriceListDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetPriceListDetailByKeysAsync}/${priceListId}/${articleId}`);
  }

  getPriceListDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, priceListId: number, filters: ColumnResponseModel[]): Observable<PagedResponseModel<PriceListDetailCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('priceListId', priceListId);

    return this._httpClient.post<PagedResponseModel<PriceListDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.GetPriceListDetailsForCaptureTable}`,
      filters, { params: params }
    );
  }

  importPriceListAs(priceListImports: Array<PriceListAsImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.put<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ImportPriceListAs}`,
      priceListImports);
  }

  importValuesPriceList(priceListImports: Array<PriceListImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.put<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ImportValuesPriceList}`,
      priceListImports);
  }

  importValuesPriceListBase(priceListImports: Array<PriceListImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.put<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ImportValuesPriceListBase}`,
      priceListImports);
  }

  importPercentagePriceList(priceListImports: Array<PriceListImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.put<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ImportPercentagePriceList}`,
      priceListImports);
  }

  exportImportErrors(alerts: Array<PreInvoicingAlertModel>): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ExportDetailConsultation}`,
      alerts, { responseType: 'blob' });
  }

  replicateArticleInOtherList(priceListDetailContractModel: PriceListDetailModel): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.ReplicateArticleInOtherList}`,
      priceListDetailContractModel);
  }

  updatePriceListDetail(priceListDetailContractModel: PriceListDetailModel): Observable<PriceListDetailModel> {
    return this._httpClient.put<PriceListDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceListDetail.UpdatePriceListDetail}`,
      priceListDetailContractModel);
  }
}
